export default __webpack_public_path__ + "static/media/logo.90316630.jpg";